import {Routes} from '@angular/router';
import {LoginComponent} from './pages/login/login.component';
import { ROUTE_PATHS } from './constants';


export const routes: Routes = [
  {
    path: '',
    redirectTo: '/kiosk',
    pathMatch: 'full',

  },
  {
    path: ROUTE_PATHS.KIOSK,
    component: LoginComponent,
  },

  {
    path: ROUTE_PATHS.STORES,
    loadChildren: () =>
      import('./pages/stores/stores-routing.module').then(
        (m) => m.StoresRoutingModule
      ),
  },
  {
    path: ROUTE_PATHS.MENU,
    loadChildren: () =>
      import('./pages/Menu/menu-routing.module').then(
        (m) => m.MenuRoutingModule
      ),
  },
  {
    path: ROUTE_PATHS.WALLPAPER,
    loadChildren: () =>
      import('./pages/wallpaper/wallpaper-routing.module').then(
        (m) => m.WallpaperRoutingModule
      ),
  },
  {
    path: ROUTE_PATHS.HOME,
    loadChildren: () =>
      import('./pages/home/home-routing.module').then(
        (m) => m.HomeRoutingModule
      ),
  },
];
